import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from "@ashvin27/react-datatable";
import { addRoleData } from "../../actions/roleActions";
import { logoutUser } from "../../actions/authActions";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { toast, ToastContainer } from "react-toastify";
import $ from "jquery";
import classnames from "classnames";
import { baseUrl } from "../pages/baseUrl";
class PasswordChange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      amount: "",
      role: "add",
      message: "",
      values: [],
      errors: {},
      type: "password",
      type1: "password",
      type2: "password",
      contactUsAddress: "",
      contactUsPhone: "",
      contactUsEmail: ""
    };
  }

  componentDidMount() {
    this.getData();
    this.getWalletAddress();
    this.getContactUs();
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.auth.user.roleManager !== undefined &&
      this.props.auth.user.roleManager !== 1
    ) {
      this.props.history.push("/dashboard");
    }
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
    if (
      nextProps.roledata !== undefined &&
      nextProps.roledata.role !== undefined &&
      nextProps.roledata.role.data !== undefined &&
      nextProps.roledata.role.data.message !== undefined &&
      nextProps.roledata.role.data.success
    ) {
      //    this.props.history.push("/transaction");
    }
  }
  getData() {
    axios
      .post(baseUrl + "/api/role-manager-data")
      .then((res) => {
        this.setState({ records: res.data, id: res.data[0].id });
      })
      .catch();
  }

  getWalletAddress() {
    axios
      .get(baseUrl + "/api/get_wallet_address")
      .then((res) => {
        if (res.data.length) {
          this.setState({ walletAddress: res.data[0].value });
        }
      })
      .catch();
  }

  getContactUs() {
    axios
      .get(baseUrl + "/api/contactUs")
      .then((res) => {
       // console.log(res.data);
        if (res.data.data.length) {
          this.setState({
            contactUsAddress: res.data.data.find(obj => obj.show_name === "address")?.value,
            contactUsPhone: res.data.data.find(obj => obj.show_name === "phone")?.value,
            contactUsEmail: res.data.data.find(obj => obj.show_name === "email")?.value
          });
        }
      })
      .catch();
  }



  handleClick = () =>
    this.setState(({ type }) => ({
      type: type === "text" ? "password" : "text",
    }));
  handleClick1 = () =>
    this.setState(({ type1 }) => ({
      type1: type1 === "text" ? "password" : "text",
    }));
  handleClick2 = () =>
    this.setState(({ type2 }) => ({
      type2: type2 === "text" ? "password" : "text",
    }));
  onChange = (e) => {
    let { name, value } = e.target;
    this.setState({ [name]: value, errMsg: "" });
    if (name === "OldPassword") {
      if (!e.target.value) {
        this.setState({
          errors: {
            OldPassword: "This field is required",
          },
        });
        return false;
      }
      this.setState({
        errors: {
          OldPassword: "",
        },
      });
    }
    if (name === "NewPassword") {
      if (!e.target.value) {
        this.setState({
          errors: {
            NewPassword: "This field is required",
          },
        });
        return false;
      }
      var passw =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%~&^*?-_])[A-Za-z\d#$@~!%^&*?-_]{8,20}$/;
      if (!e.target.value.match(passw)) {
        this.setState({
          errors: {
            NewPassword:
              "Password must 8 characters and contain at least one upper case letter, one lower case letter, one number, and one special character",
          },
        });
        return false;
      }
      this.setState({
        errors: {
          NewPassword: "",
        },
      });
    }
    if (name === "CPassword") {
      if (!e.target.value) {
        this.setState({
          errors: {
            CPassword: "This field is required",
          },
        });
        return false;
      }
      var passw =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%~&^*?-_])[A-Za-z\d#$@~!%^&*?-_]{8,20}$/;
      if (!e.target.value.match(passw)) {
        this.setState({
          errors: {
            CPassword:
              "Password must 8 characters and contain at least one upper case letter, one lower case letter, one number, and one special character",
          },
        });
        return false;
      }
      if (this.state.NewPassword !== e.target.value) {
        this.setState({
          errors: {
            CPassword: "Confirm password does not match",
          },
        });
        return false;
      }
      this.setState({
        errors: {
          CPassword: "",
        },
      });
    }
  };
  onChangewalletAddress = (e) => {
    let { name, value } = e.target;
    let errors = this.state.errors;
    // console.log(errors);
    errors[name] = "";
    if (value == "") {
      errors[name] = "This field is required.";
    }
    this.setState({ [name]: value, errors });
  }

  onUpdateBalance = (e) => {
    e.preventDefault();
    const config = {
      headers: {
        Authorization: localStorage.getItem("jwtToken"),
      },
    };

    if (
      !this.state.NewPassword &&
      !this.state.OldPassword &&
      !this.state.CPassword
    ) {
      this.setState({
        errors: {
          CPassword: "This field is require",
          NewPassword: "This field is require",
          OldPassword: "This field is require",
        },
      });
      return false
    }
    axios
      .post(
        baseUrl + "/api/ChangePassword",
        {
          NewPassword: this.state.NewPassword,
          OldPassword: this.state.OldPassword,
          CPassword: this.state.CPassword,
        },
        config
      )
      .then((res) => {
        if (res.data.message) {
          // this.setState({ "NewPassword": "","OldPassword": "","CPassword": ""  });
          toast(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          this.props.logoutUser();
          this.props.history.push('/login');
        }
        // if (res.data.email) {
        //   toast(res.data.email, {
        //     position: toast.POSITION.TOP_CENTER,
        //   });
        // }
      })
      .catch();
  };

  onUpdateWallet = (e) => {
    e.preventDefault();
    const config = {
      headers: {
        Authorization: localStorage.getItem("jwtToken"),
      },
    };

    if (!this.state.newWalletAddress || this.state.newWalletAddress == "") {
      this.setState({
        errors: {
          newWalletAddress: "This field is required"
        },
      });
      return false
    }
    axios
      .post(
        baseUrl + "/api/changeWalletAddress",
        {
          newWalletAddress: this.state.newWalletAddress,

        },
        config
      )
      .then((res) => {
        if (res.data.status) {
          this.setState({ "newWalletAddress": "" });
          this.getWalletAddress();
          toast(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });

          // this.props.history.push('/transaction');
        }

      })
      .catch();
  };

  onUpdateContactUs = (e) => {
    e.preventDefault();
    const config = {
      headers: {
        Authorization: localStorage.getItem("jwtToken"),
      },
    };

    if (!this.state.contactUsAddress || this.state.contactUsAddress == "") {
      this.setState({
        errors: {
          contactUsAddress: "This field is required"
        },
      });
      return false
    }
    if (!this.state.contactUsPhone || this.state.contactUsPhone == "") {
      this.setState({
        errors: {
          contactUsPhone: "This field is required"
        },
      });
      return false
    }
    if (!this.state.contactUsEmail || this.state.contactUsEmail == "") {
      this.setState({
        errors: {
          contactUsEmail: "This field is required"
        },
      });
      return false
    }

    axios
      .post(
        baseUrl + "/api/update_contactUs",
        {
          ContactUs: {
            address: this.state.contactUsAddress,
            phone: this.state.contactUsPhone,
            email: this.state.contactUsEmail
          }
        },
        config
      )
      .then((res) => {
        if (res.data.status) {
          this.getContactUs();
          toast(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });

          // this.props.history.push('/transaction');
        }

      })
      .catch();
  };

  render() {
    const { errors } = this.state;

    return (
      <div>
        <Navbar />
        <div className="d-flex" id="wrapper">
          <Sidebar />
          <div id="page-content-wrapper">
            <div className="container-fluid">
              {" "}
              <button className="btn btn-link mt-3" id="menu-toggle">
                <FontAwesomeIcon icon={faList} />
              </button>
              <h4 className="mt-2 man_hadding mb-3">Settings</h4>
              <div className="man_white_box">
                <div className="in_page row">
                  <div className="col-md-6">

                    <label style={{ fontSize: "18px", fontWeight: "700" }}>
                      Change Current Password
                    </label>
                    <div className=" padding_d">
                      <form
                        noValidate
                        onSubmit={this.onUpdateBalance}
                        id="add-user"
                      >
                        <div className="">
                          <div className="tab-content ">
                            <div className="tab-pane active show" id="details">
                              <div className="row mt-2">
                                <div className="col-md-3">
                                  <label htmlFor="password">
                                    Current Password
                                  </label>
                                </div>
                                <div className="col-md-9 ">
                                  <div className="eye_pass">
                                    <input
                                      onChange={this.onChange}
                                      name="OldPassword"
                                      value={this.state.OldPassword}
                                      type={this.state.type}
                                      className={classnames("form-control", {
                                        invalid: errors.email,
                                      })}
                                    />
                                    <span
                                      className="password__show eye1"
                                      onClick={this.handleClick}
                                    >
                                      {this.state.type === "text" ? (
                                        <i className="las la-eye"></i>
                                      ) : (
                                        <i className="las la-low-vision"></i>
                                      )}
                                    </span>
                                  </div>
                                  <span className="text-danger">
                                    {errors.OldPassword}
                                  </span>
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-md-3">
                                  <label htmlFor="amount">New Password</label>
                                </div>
                                <div className="col-md-9 ">
                                  <div className="eye_pass">
                                    <input
                                      onChange={this.onChange}
                                      value={this.state.NewPassword}
                                      name="NewPassword"
                                      type={this.state.type1}
                                      className="form-control"
                                    />
                                    <span
                                      className="password__show eye1"
                                      onClick={this.handleClick1}
                                    >
                                      {this.state.type1 === "text" ? (
                                        <i className="las la-eye"></i>
                                      ) : (
                                        <i className="las la-low-vision"></i>
                                      )}
                                    </span>
                                  </div>
                                  <span className="text-danger">
                                    {errors.NewPassword}
                                  </span>
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-md-3">
                                  <label htmlFor="amount">
                                    Confirm Password
                                  </label>
                                </div>
                                <div className="col-md-9 ">
                                  <div className="eye_pass">
                                    <input
                                      onChange={this.onChange}
                                      error={errors.amount}
                                      name="CPassword"
                                      type={this.state.type2}
                                      value={this.state.CPassword}
                                      className={classnames("form-control", {
                                        invalid: errors.amount,
                                      })}
                                    />
                                    <span
                                      className="password__show eye1"
                                      onClick={this.handleClick2}
                                    >
                                      {this.state.type2 === "text" ? (
                                        <i className="las la-eye"></i>
                                      ) : (
                                        <i className="las la-low-vision"></i>
                                      )}
                                    </span>
                                  </div>
                                  <span className="text-danger">
                                    {errors.CPassword}
                                  </span>
                                </div>
                              </div>
                              <hr />
                              <button
                                className="btn btn-primary "
                                type="submit"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>

                    </div>
                  </div>
                  <div className="col-md-6">

                    <label style={{ fontSize: "18px", fontWeight: "700" }}>
                      Change Coin Exchange Wallet Address
                    </label>
                    <div className=" padding_d">
                      <form
                        noValidate
                        onSubmit={this.onUpdateWallet}
                        id="add-user"
                      >
                        <div className="">
                          <div className="tab-content ">
                            <div className="tab-pane active show" id="details">
                              <div className="row mt-2">
                                <div className="col-md-3">
                                  <label htmlFor="password">
                                    Current Wallet Address
                                  </label>
                                </div>
                                <div className="col-md-9 ">
                                  <div className="eye_pass">
                                    <input
                                      disabled={true}
                                      value={this.state.walletAddress}
                                      type="text"
                                      className={classnames("form-control")}
                                    />

                                  </div>
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-md-3">
                                  <label htmlFor="amount">New Wallet Adress</label>
                                </div>
                                <div className="col-md-9 ">
                                  <div className="eye_pass">
                                    <input
                                      onChange={this.onChangewalletAddress}
                                      value={this.state.newWalletAddress}
                                      name="newWalletAddress"
                                      type="text"
                                      className="form-control"
                                    />

                                  </div>
                                  <span className="text-danger">
                                    {errors.newWalletAddress}
                                  </span>
                                </div>
                              </div>
                              <div className="row mt-2">


                              </div>
                              <hr />
                              <button
                                className="btn btn-primary "
                                type="submit"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>

                  </div>
                </div>
              </div>
              <div className="man_white_box" style={{ marginTop: "5px" }}>
                <div className="in_page row">
                  <div className="col-md-6">

                    <label style={{ fontSize: "18px", fontWeight: "700" }}>
                      Change Contact us Detail
                    </label>
                    <div className=" padding_d">
                      <form
                        noValidate
                        onSubmit={this.onUpdateContactUs}
                        id="add-user"
                      >
                        <div className="">
                          <div className="tab-content ">
                            <div className="tab-pane active show" id="details">
                              <div className="row mt-2">
                                <div className="col-md-3">
                                  <label htmlFor="password">
                                    Address:
                                  </label>
                                </div>
                                <div className="col-md-9 ">
                                  <div className="eye_pass">
                                    <textarea
                                      onChange={this.onChange}
                                      name="contactUsAddress"
                                      value={this.state.contactUsAddress}
                                      type=""
                                      className={classnames("form-control", {
                                        invalid: errors.address,
                                      })}
                                    />

                                  </div>
                                  <span className="text-danger">
                                    {errors.contactUsAddress}
                                  </span>
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-md-3">
                                  <label htmlFor="amount">Phone</label>
                                </div>
                                <div className="col-md-9 ">
                                  <div className="eye_pass">
                                    <input
                                      onChange={this.onChange}
                                      value={this.state.contactUsPhone}
                                      name="contactUsPhone"
                                      type="text"
                                      className="form-control"
                                    />

                                  </div>
                                  <span className="text-danger">
                                    {errors.contactUsPhone}
                                  </span>
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-md-3">
                                  <label htmlFor="amount">
                                    Email
                                  </label>
                                </div>
                                <div className="col-md-9 ">
                                  <div className="eye_pass">
                                    <input
                                      onChange={this.onChange}
                                      error={errors.amount}
                                      name="contactUsEmail"
                                      type="email"
                                      value={this.state.contactUsEmail}
                                     className="form-control"
                                    />


                                  </div>
                                  <span className="text-danger">
                                    {errors.contactUsEmail}
                                  </span>
                                </div>
                              </div>
                              <hr />
                              <button
                                className="btn btn-primary "
                                type="submit"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>
          <ToastContainer />
        </div>
      </div>
    );
  }
}

PasswordChange.propTypes = {
  addRoleData: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  roledata: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  roledata: state.roledata,
  errors: state.errors,
});
export default connect(mapStateToProps, { addRoleData, logoutUser })(
  withRouter(PasswordChange)
);
